(function(){
  if (window.__sheepOffer) { window.__sheepOffer.scan(); return; }
  var RX = /iphone|samsung|galaxy/i;

  function modelKeys(raw){
    if(!raw) return [];
    var s = String(raw).replace(/magsafe/gi,'').replace(/\(.*?\)/g,'').trim();
    var keys=[], brand=null;
    s.split('/').forEach(function(p){
      p = p.trim(); if(!p) return;
      p = p.replace(/^galaxy\s+/i,'Samsung ');
      var m = p.match(/^(iphone|samsung)\s+(.*)$/i);
      if(m){ brand=m[1].toUpperCase(); keys.push((brand+' '+m[2]).toUpperCase().replace(/\s+/g,' ').trim()); }
      else if(brand){ keys.push((brand+' '+p).toUpperCase().replace(/\s+/g,' ').trim()); }
    });
    return keys;
  }
  function modelOpt(opts){ for(var i=0;i<opts.length;i++){ if(RX.test(opts[i])) return opts[i]; } return null; }
  function otherOpt(opts){ for(var i=0;i<opts.length;i++){ if(!RX.test(opts[i])) return opts[i]; } return ''; }
  function overlaps(a,b){ return a.some(function(k){ return b.indexOf(k)>-1; }); }
  function baht(cents){ return '฿' + Math.round(cents/100).toLocaleString('en-US'); }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function short(m){ return String(m).replace(/^iphone\s+/i,'').replace(/^galaxy\s+/i,''); }

  /* ---------- iPad ----------
     กลุ่มฟิล์ม: 1 mini 6/7 · 2 9.7 · 3 10.2 · 4 10.9/11 Gen10/11 · 5 Air 4/5 + Pro 11 Gen1–4
                 6 Air 11 M2–M4 · 7 Pro 11 M4/M5 · 8 Pro 12.9 · 9 Air 13 · 10 Pro 13 M4/M5 */
  function ipadGroups(s){
    s = String(s||'').toLowerCase().replace(/\s+/g,' ');
    if(!/ipad/.test(s)) return null;
    if(/mini/.test(s)) return [1];
    if(/12\.9/.test(s)) return [8];
    if(/air ?13/.test(s)) return [9];
    if(/pro ?13/.test(s)) return [10];
    if(/10\.5/.test(s)) return [];
    if(/9\.7/.test(s)) return [2];
    if(/10\.2/.test(s)) return [3];
    if(/10\.9|gen ?10/.test(s)) return [4];
    if(/pro ?11/.test(s)) return /m4|m5/.test(s) ? [7] : [5];
    if(/air ?11/.test(s)){
      var g=[]; if(/\(air|air ?4/.test(s)) g.push(5); if(/m2|m3|m4/.test(s)) g.push(6);
      return g.length ? g : [5,6];
    }
    return null;
  }
  var TAG_GROUP = {
    iPadMini6:1, iPadMini7:1, iPad97Gen6:2, iPad102Gen7:3, iPad102Gen8:3, iPad102Gen9:3,
    iPadGen10:4, iPadA16:4, iPadAir4:5, iPadAir5:5, iPadPro11Gen1:5, iPadPro11Gen2:5, iPadPro11Gen3:5, iPadPro11Gen4:5,
    iPadAir11M2:6, iPadAir11M3:6, iPadAir11M4:6, iPadPro11M4:7, iPadPro11M5:7,
    iPadPro129Gen3:8, iPadPro129Gen4:8, iPadPro129Gen5:8, iPadPro129Gen6:8,
    iPadAir13M2:9, iPadAir13M3:9, iPadAir13M4:9, iPadPro13M4:10, iPadPro13M5:10
  };
  function tagGroups(tags){
    var g={}; (tags||[]).forEach(function(t){ var k=TAG_GROUP[String(t).replace(/^model_/,'')]; if(k) g[k]=1; });
    return Object.keys(g).map(Number).sort(function(a,b){return a-b;});
  }
  function caseIpadGroups(opts, tags){
    for(var i=0;i<opts.length;i++){ var g = ipadGroups(opts[i]); if(g) return g; }
    var all = tagGroups(tags);
    for(var j=0;j<opts.length;j++){            // กระเป๋า: ขนาดเป็นนิ้ว
      var o = String(opts[j]);
      if(/15\s*[–-]\s*16/.test(o)) return [];
      if(/13\s*[–-]\s*14/.test(o)) return all.filter(function(x){ return x>=8; });
      if(/9\.7\s*[–-]\s*11/.test(o)) return all.filter(function(x){ return x>=2 && x<=7; });
    }
    return all;
  }
  function filmType(title){
    var t = String(title);
    if(/privacy/i.test(t)) return [5,'Privacy 360'];
    if(/blue ?light/i.test(t)) return [4,'Blue Light Cut'];
    if(/ด้าน/.test(t)) return [3,'กระจกด้าน HD'];
    if(/paperlike/i.test(t)) return [6,'กระจกกระดาษ'];
    if(/ฟิล์มกระดาษ/.test(t)) return [2,'ฟิล์มกระดาษ'];
    if(/กระจกใส/.test(t)) return [1,'กระจกใส'];
    return [9,t];
  }

  function renderIpad(row, data, groups){
    var films = data.film.filter(function(v){ return v.a; }).map(function(v){
      var g = ipadGroups(v.o[0]); var ft = filmType(v.t);
      return {id:v.id, p:v.p, u:v.u, g:(g&&g.length===1)?g[0]:0, m:v.o[0], r:ft[0], l:ft[1]};
    }).filter(function(v){ return groups.indexOf(v.g)>-1; });
    if(!films.length){ row.hidden=true; row.innerHTML=''; return false; }
    films.sort(function(a,b){ return a.g-b.g || a.r-b.r; });
    var gList=[], gName={};
    films.forEach(function(v){ if(!gName[v.g]){ gName[v.g]=v.m; gList.push(v.g); } });

    var prev = row.querySelector('[data-offer-check]');
    var wasChecked = prev ? prev.checked : false;
    var keepG = row.getAttribute('data-g');
    var curG = gList.indexOf(Number(keepG))>-1 ? Number(keepG) : gList[0];

    var html = '<label class="sheep-offer__head"><input type="checkbox" data-offer-check>'+
      '<span class="sheep-offer__name" data-offer-name></span>'+
      '<span class="sheep-offer__price" data-offer-price></span></label>';
    if(gList.length>1){
      html += '<div class="sheep-offer__select"><span>รุ่น:</span><select data-offer-model>';
      gList.forEach(function(g){ html += '<option value="'+g+'"'+(g===curG?' selected':'')+'>'+esc(gName[g])+'</option>'; });
      html += '</select></div>';
    }
    html += '<div class="sheep-offer__opts" data-offer-types></div>';
    row.innerHTML = html; row.hidden=false;
    row.querySelector('[data-offer-check]').checked = wasChecked;

    function drawTypes(){
      var list = films.filter(function(v){ return v.g===curG; });
      var box = row.querySelector('[data-offer-types]');
      var h='';
      list.forEach(function(v,i){
        h += '<label class="sheep-offer__chip"><input type="radio" name="sheep-offer-ipad" value="'+v.id+'"'+(i===0?' checked':'')+'><span>'+esc(v.l)+'</span></label>';
      });
      h += '<a class="sheep-offer__link" data-offer-link target="_blank" rel="noopener">ดูสินค้า ›</a>';
      box.innerHTML = h;
      row.querySelector('[data-offer-name]').textContent = 'ฟิล์ม SHEEP สำหรับ ' + gName[curG];
      row.setAttribute('data-g', curG);
    }
    function price(){
      var sel = row.querySelector('input[type=radio]:checked');
      var v = null; films.forEach(function(f){ if(sel && String(f.id)===sel.value) v=f; });
      if(!v) return;
      row.setAttribute('data-vid', v.id);
      row.querySelector('[data-offer-price]').innerHTML = '<s>'+baht(v.p)+'</s><b>'+baht(Math.max(0, v.p - data.discount))+'</b>';
      var a = row.querySelector('[data-offer-link]'); if(a && v.u) a.href = v.u + '?variant=' + v.id;
    }
    row.onchange = function(e){
      if(e.target && e.target.matches('[data-offer-model]')){ curG = Number(e.target.value); drawTypes(); }
      price();
      if(e.target && !e.target.matches('[data-offer-check]')) row.querySelector('[data-offer-check]').checked = true;
    };
    drawTypes(); price();
    return true;
  }

  /* ---------- iPhone / Samsung ---------- */
  function matches(list, keys){
    return list.filter(function(v){
      if(!v.a) return false;
      var m = modelOpt(v.o); return m && overlaps(modelKeys(m), keys);
    });
  }
  function labels(list){
    var models={};
    list.forEach(function(v){ models[modelOpt(v.o)]=1; });
    var multi = Object.keys(models).length > 1;
    return list.map(function(v){ var l=otherOpt(v.o); return multi ? l+' · '+short(modelOpt(v.o)) : l; });
  }
  function caseModelName(opts){ var m = modelOpt(opts)||''; return m.replace(/\s*magsafe/i,'').trim(); }

  function renderRow(row, kind, list, data, caseName){
    if(!list.length){ row.hidden=true; row.innerHTML=''; return; }
    var title = kind==='film' ? 'ฟิล์ม SHEEP สำหรับ ' : 'กระจกกล้อง SHEEP สำหรับ ';
    var lbl = labels(list);
    var prev = row.querySelector('input[type=checkbox]');
    var wasChecked = prev ? prev.checked : false;
    var html = '<label class="sheep-offer__head"><input type="checkbox" data-offer-check>'+
      '<span class="sheep-offer__name">'+esc(title+caseName)+'</span>'+
      '<span class="sheep-offer__price" data-offer-price></span></label>';
    if(kind==='film'){
      html += '<div class="sheep-offer__opts">';
      list.forEach(function(v,i){
        html += '<label class="sheep-offer__chip"><input type="radio" name="sheep-offer-film" value="'+v.id+'"'+(i===0?' checked':'')+'><span>'+esc(lbl[i])+'</span></label>';
      });
      html += '<a class="sheep-offer__link" data-offer-link target="_blank" rel="noopener">ดูสินค้า ›</a>' + '</div>';
    } else {
      html += '<div class="sheep-offer__select"><span>สี:</span><select data-offer-select>';
      list.forEach(function(v,i){ html += '<option value="'+v.id+'">'+esc(lbl[i])+'</option>'; });
      html += '</select>' + '<a class="sheep-offer__link" data-offer-link target="_blank" rel="noopener">ดูสินค้า ›</a>' + '</div>';
    }
    row.innerHTML = html; row.hidden=false;
    row.querySelector('[data-offer-check]').checked = wasChecked;
    var byId={}; list.forEach(function(v){ byId[v.id]=v; });
    function price(){
      var sel = row.querySelector('input[type=radio]:checked, select');
      var v = byId[sel ? sel.value : list[0].id];
      row.setAttribute('data-vid', v.id);
      var after = Math.max(0, v.p - data.discount);
      row.querySelector('[data-offer-price]').innerHTML = '<s>'+baht(v.p)+'</s><b>'+baht(after)+'</b>';
      var a = row.querySelector('[data-offer-link]'); if(a && v.u) a.href = v.u + '?variant=' + v.id;
    }
    row.onchange = function(e){
      price();
      if(e.target && !e.target.matches('[data-offer-check]')) row.querySelector('[data-offer-check]').checked = true;
    };
    price();
  }

  function render(box){
    var data; try{ data = JSON.parse(box.querySelector('[data-sheep-offer-data]').textContent); }catch(e){ return; }
    var form = box.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('input[name="id"]');
    var id = input ? String(input.value) : '';
    if(box.getAttribute('data-for') === id) return;
    box.setAttribute('data-for', id);
    var entry = data['case'][id];
    var opts = entry && entry.a ? entry.o : null; // เคส/กระเป๋าหมดสต็อก → ซ่อนกล่อง
    var filmRow = box.querySelector('[data-row="film"]');
    var glassRow = box.querySelector('[data-row="glass"]');

    if(data.ipad){
      glassRow.hidden = true; glassRow.innerHTML = '';
      var groups = opts ? caseIpadGroups(opts, data.tags) : [];
      var ok = groups.length ? renderIpad(filmRow, data, groups) : (filmRow.hidden=true, filmRow.innerHTML='', false);
      box.hidden = !ok;
      return;
    }
    var keys = opts ? modelKeys(modelOpt(opts)) : [];
    var films = keys.length ? matches(data.film, keys) : [];
    var glasses = keys.length ? matches(data.glass, keys) : [];
    var name = opts ? caseModelName(opts) : '';
    renderRow(filmRow, 'film', films, data, name);
    renderRow(glassRow, 'glass', glasses, data, name);
    box.hidden = !(films.length || glasses.length);
  }

  function scan(){ document.querySelectorAll('[data-sheep-offer]').forEach(render); }

  function selectedItems(form){
    var items=[];
    form.querySelectorAll('[data-sheep-offer]:not([hidden]) .sheep-offer__row:not([hidden])').forEach(function(row){
      var cb = row.querySelector('[data-offer-check]');
      var vid = row.getAttribute('data-vid');
      if(cb && cb.checked && vid) items.push({id: Number(vid), quantity: 1});
    });
    return items;
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.querySelector || !form.querySelector('[data-sheep-offer]')) return;
    if(form.__sheepAdding) return;
    var sub = e.submitter;
    if(sub && sub.name && sub.name !== 'add') return; // e.g. Buy it now → skip
    var items = selectedItems(form);
    if(!items.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})})
      .catch(function(){})
      .then(function(){
        form.__sheepAdding = true;
        try { sub ? form.requestSubmit(sub) : form.requestSubmit(); } catch(err){ form.submit(); }
        setTimeout(function(){ form.__sheepAdding = false; }, 0);
        form.querySelectorAll('[data-sheep-offer] [data-offer-check]').forEach(function(cb){ cb.checked=false; });
      });
  }, true);

  window.__sheepOffer = { scan: scan };
  scan();
  setInterval(scan, 400);
})();
